if (!customElements.get('wl-cart-upsell')) {
  customElements.define(
    'wl-cart-upsell',
    class WeisLightsCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('.wl-squeegee-offer__status');
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.form || !this.button || this.button.disabled) return;

        const variantId = Number(this.form.querySelector('[name="id"]')?.value || 0);
        if (!variantId) return;

        const oldText = this.button.textContent;
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.textContent = 'Adding…';
        if (this.status) this.status.textContent = '';

        const cartDrawer = document.querySelector('cart-drawer');
        const isDrawer = this.dataset.context === 'drawer' && cartDrawer;
        const payload = {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { '_WeisLights cart offer': 'Squeegee' },
            },
          ],
        };

        if (isDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add the Squeegee.');

          if (isDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
            if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(document.activeElement);
            cartDrawer.renderContents(data);
          } else {
            window.location.reload();
          }
        } catch (error) {
          this.button.disabled = false;
          this.button.removeAttribute('aria-disabled');
          this.button.textContent = oldText;
          if (this.status) this.status.textContent = error.message || 'Could not add the Squeegee. Please try again.';
        }
      }
    }
  );
}
